import PropTypes from 'prop-types'

const AdAccountAfter = ({ after }) => (
  <tr>
    <th scope="row">상태</th>
    <td>
      <div className="inner_cell">{after.status}</div>
    </td>
  </tr>
)
AdAccountAfter.propTypes = {
  after: PropTypes.shape({
    status: PropTypes.string,
  }),
}
export default AdAccountAfter
